<template>
  <v-container
    fluid
    grid-list-md
    text-xs-center
    style="min-height: 93.4vh"
  >
    <v-layout
      row
      wrap
    >
      <v-toolbar
        scroll-target="#scrolling-home"
        style="z-index: 1"
        extended
      >
        <v-toolbar-title
          v-show="!$vuetify.breakpoint.xsOnly"
        >
          Reporte de asistencia
        </v-toolbar-title>
        <v-toolbar-title
          v-show="!$vuetify.breakpoint.xsOnly"
          style="margin-left: 1125px;"
        >
          <v-btn
            icon
            to="../reports"
          >  
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-title>
        <template v-slot:extension>
          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              sm6
              md2
              lg2
              offset-lg1
            />
            <v-flex
              xs12
              sm6
              md2
              lg2
            >
              <v-menu
                v-model="modalF"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    id="first"
                    :value="momentFormatFirst"
                    label="Fecha de inicio"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  header-color="primary"
                  color="secondary"
                  locale="es-419"
                  v-model="timeFirst"
                  scrollable
                />
              </v-menu>
            </v-flex>
            <v-flex
              xs12
              sm6
              md2
              lg2
            >
              <v-menu
                v-model="modalL"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="momentFormatLast"
                    id="last"
                    label="Fecha de término"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  header-color="primary"
                  color="secondary"
                  locale="es-419"
                  v-model="timeLast"
                  scrollable
                />
              </v-menu>
            </v-flex>
            <v-flex
              xs12
              sm6
              md4
              lg4
              class="titleSearch"
            >
              <v-text-field
                flat
                label="Buscar por nombre de taller"
                append-outer-icon="search"
                clearable
                solo-inverted
                hide-details
                @click:append-outer="filterSearch(false)"
                @click:clear="filterSearch(true)"
                @keyup.enter="filterSearch(false)"
                v-model="search"
              />
            </v-flex>
            <v-flex
              xs12
              sm4
              md2
              lg1
            >
              <v-btn
                color="primary darken-1"
                flat
                @click="clearFilters()"
              >
                Limpiar
              </v-btn>
            </v-flex>
          </v-layout>
        </template>
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0;"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style=" z-index:99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                  v-on="on"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Más Opciones</span>
            </v-tooltip>
          </template>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="exportToPDF"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar XLSX</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-toolbar
        height="95"
        style="padding-top: 20px;"
        elevation-3
        v-if="false"
        v-show="!$vuetify.breakpoint.xsOnly"
      >
        <v-layout v-if="false">
          <v-flex style="text-align: -webkit-center;">
            <v-img
              style="background: #025a90; border-radius:50%;"
              max-height="50"
              max-width="50"
            >
              <p style="margin-top: 15px; color:white;">
                {{ "0" }}
              </p>
            </v-img>
            <p>Total Aforo</p>
          </v-flex>
          
          <v-flex
            style="text-align: -webkit-center;"
          >
            <v-img
              style="background: #F1C40F; border-radius:50%;"
              max-height="50"
              max-width="50"
            >
              <p style="margin-top: 15px; color:white;">
                {{ "0" }}
              </p>
            </v-img>
            <p>Total de Alumnos</p>
          </v-flex>
        </v-layout> 
        <v-speed-dial
          key="1"
          v-model="buttonFab.fab"
          absolute
          bottom
          left
          direction="bottom"
          open-on-hover
          transition="scale-transition"
          style="bottom: 0;"
        >
          <template v-slot:activator>
            <v-tooltip right>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-model="buttonFab.fab"
                  style=" z-index:99"
                  color="gradiente"
                  dark
                  fab
                  :small="$vuetify.breakpoint.xsOnly"
                  v-on="on"
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </template>
              <span>Más Opciones</span>
            </v-tooltip>
          </template>
          <v-tooltip right>
            <v-btn
              fab
              dark
              small
              color="gradiente"
              slot="activator"
              @click="exportToPDF"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
            <span>Descargar XLS</span>
          </v-tooltip>
        </v-speed-dial>
      </v-toolbar>
      <v-container
        elevation-2
        fluid
        id="scrolling-activity"
        style="max-height: 75vh"
        class="table-full"
      >
        <v-layout
          row
          wrap
        >
          <v-flex xs12>
            <v-data-table
              :headers="headers"
              :rows-per-page-items="[25, 50, 100]"
              rows-per-page-text="Registros por página"
              :items="entries"
              :loading="working.wEntries"
              :pagination.sync="pagination"
              item-key="id"
              no-results-text="No se encontraron coincidencias"
              no-data-text="No hay registros"
              class="delivery-table"
            >
              <template v-slot:headers>
                <tr>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Fecha de asistencia
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Taller
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Salón
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Hora del taller
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Nombre
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Apellidos
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    CURP
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 210px; max-width: 175px; min-width: 175px"
                  >
                    Teléfono
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 135px; max-width: 135px; min-width: 135px"
                  >
                    Genero
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    Correo
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 135px; max-width: 135px; min-width: 135px"
                  >
                    C.P.
                  </th>
                  <th
                    class="text-xs-left"
                    style="width: 135px; max-width: 135px; min-width: 135px"
                  >
                    Colonia
                  </th>
                </tr>
              </template>
              
              <template v-slot:items="props">
                <!-- Nueva entrada con el socket -->
                <tr


                  :class="props.item.isNew ? 'new-entry' : ''"
                >
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ props.item.attendanceDate | formatDate }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ getWorkshopName(props.item) }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ getClassRoomName(props.item) }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ getWorkshopTime(props.item) }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    {{ props.item.student.firstName }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    <!-- Solicitado -->
                    {{ props.item.student.lastName }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    <!-- Camino -->
                    {{ props.item.student.personId }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 210px; max-width: 175px; min-width: 175px"
                  >
                    <!-- Entregado -->
                    {{ props.item.student.phone }}
                  </td>
                  
                  <td
                    class="text-xs-left"
                    style="width: 135px; max-width: 135px; min-width: 135px"
                  >
                    <!-- Entregado -->
                    {{ props.item.student.gender === 'MALE' ? 'Masculino' : 'Femenino' }}
                  </td>

                  <td
                    class="text-xs-left"
                    style="width: 200px; max-width: 200px; min-width: 200px"
                  >
                    <!-- Entregado -->
                    {{ props.item.student.email }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 135px; max-width: 135px; min-width: 135px"
                  >
                    <!-- Entregado -->
                    {{ props.item.student.zipCode }}
                  </td>
                  <td
                    class="text-xs-left"
                    style="width: 135px; max-width: 135px; min-width: 135px"
                  >
                    <!-- Entregado -->
                    {{ props.item.student.suburb }}
                  </td>
                </tr>
              </template>
              <!-- <template v-slot:expand="props">
                <StudentDelivery
                  v-if="expandables.Delivery"
                  :parentName="props.item.parentName"
                  :parentLastName="props.item.parentLastName || 'N/A '"
                  :door="props.item.door"
                  :carModel="props.item.carModel || 'Caminando'"
                  :carColor="props.item.carColor || ''"
                  :plates="props.item.plates || ''"
                  :typeUser="props.item.typeReq"
                />
              </template> -->
              <!-- Paginación -->
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <loading
      v-model="working.wLoading"
      text="Trabajando"
    />
    <success
      v-model="toast.success"
      text="Operación exitosa"
    />
    <error
      v-model="toast.failed"
      text="Ups ocurrió un error"
    />
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import loading from "../../Dialogs/Loading";
import success from "../../Dialogs/Success";
import error from "../../Dialogs/Error";
import jsPDF from "jspdf";
import { isEmptyOrNull } from '../../../plugins/GeneralMethods';

export default {
  components: {
    loading,
    success,
    error,
  },
  data: () => ({
    expandables: {
      Delivery: false,
      isOculto: false,
    },
    buttonFab: {
      fab: false,
      hidden: false
    },
    colapSel: null,
    pagination: {
      sortBy: "name",
    },
    filters: {
      search: "",
    },
    modalF: false,
    modalL: false,
    timeFirst: moment().format("YYYY-MM-DD"),
    timeLast: moment().format("YYYY-MM-DD"),
    entries: [],
    grades: [],
    levels: [],
    delivers: [],
    json_data: [],
    labels: {
      level: 'Nivel',
      grade: 'Grupo',
      firstName: 'Nombre',
      lastName: 'Apellido',
      personId: 'Matrícula',
      createdAt: 'Fecha/Hora Solicitado',
      calledTime: 'Fecha/Hora Camino',
      deliveryTime: 'Fecha/Hora Entregado',
      parentName: 'Nombre Solicitante',
      parentLastName: 'Apellido Solicitante',
      typeReq: 'Usuario',
      door: 'Puerta',
      carModel: 'Auto',
      carColor: 'Color',
      plates: 'Placas'
    },
    fields: ['level', 'grade','firstName', 'lastName', 'personId', 'createdAt', 'calledTime', 'deliveryTime', 'parentName', 'parentLastName', 'typeReq', 'door', 'carModel', 'carColor', 'plates'],
    search: "",
    gradeGroup: {},
    level: {},

    toast: {
      success: false,
      failed: false,
    },
    working: {
      wEntries: false,
      wLoading: false,
    },
    //Cambiar
    headers: [
      {
        text: "Nivel",
        align: "left",
        value: "level",
      },
      {
        text: "Grupo",
        align: "left",
        value: "grade",
      },
      {
        text: "Nombres",
        align: "left",
        value: "firstName",
      },
      {
        text: "Apellido",
        align: "left",
        value: "lastName",
      },
      {
        text: "Matrícula",
        align: "left",
        value: "personId",
      },
      {
        text: "Solictado",
        value: "requestedTime",
        align: "left",
      },
      {
        text: "EnCamino",
        value: "calledTime",
        align: "left",
      },
      {
        text: "Entregado",
        value: "deliveryTime",
        align: "left",
      },
      {
        text: "Mas informacion",
        value: "",
        align: "left",
      },
      {
        text: "Mas informacion",
        value: "",
        align: "left",
      },
      {
        text: "Mas informacion",
        value: "",
        align: "left",
      },
      {
        text: "Mas informacion",
        value: "",
        align: "left",
      }
    ],
    connected: false,
  }),
  filters: {
    
  },
  methods: {
    getWorkshopName(item) {
      var course = item.classSession.course
      if (!isEmptyOrNull(course.name)){
          return course.name
      }  
      return ""
    },
    getClassRoomName(item) {
      var classroom = item.classSession
      if (!isEmptyOrNull(classroom)){
        if (!isEmptyOrNull(classroom.course)){
          if (!isEmptyOrNull(classroom.course.classroom)){
            return classroom.course.classroom.classroomName
          }  
        }   
      }  
      return ""
    },
    getWorkshopTime(item){
        var course = item.classSession.course
        if (!isEmptyOrNull(course.timeSchedule)){
            return course.timeSchedule
        }  
        return ""
    },   
    clearFilters() {
        this.filters.search = ""
        this.search = ""
        this.timeFirst = moment().format("YYYY-MM-DD")
        this.timeLast = moment().format("YYYY-MM-DD")
        this.pagination.page = 1
        this.getEntries()
    },
    filterSearch(clean) {
      if (clean) {
        this.filters.search = "";
      } else {
        this.filters.search = this.search ? this.search : "";
      }

      if (!this.working.wLoading) {
        this.getEntries();
      }
    },
    exportToPDF() {
      // var self = this;
      // this.callApi(function (items) {
      //   self.createEntriesPDF(self.timeFirst, self.timeLast, items);
      // }, true);
      var params = {};
      params.from = this.timeFirst
      params.to = this.timeLast
      if (!isEmptyOrNull(this.filters.search)){
        params.search = this.filters.search
      }
      this.working.wLoading = true
      this.$store
        .dispatch("reports/getAllReportAllWorkShopXLS", params)
        .then(response => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-ingresos.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          this.working.wLoading = false;
          this.toast.success = true;
        })
        .catch(error => {
          this.working.wLoading = false
          this.toast.failed = true;
          console.log(error);
        });
    },
    getEntries() {
      var self = this;
      this.callApi(function (items) {
        self.entries = items;
      });
    },

    //Datos
    callApi(callback, ignorePagination) {
      this.working.wEntries = true;
      let pageSize = this.pagination.rowsPerPage == -1 ? this.totalNotices : this.pagination.rowsPerPage;
      let currentPage = this.pagination.page - 1;
      let offset = currentPage * pageSize;

      var params = {};

      if (!ignorePagination) {
        params.size = pageSize
        params.offset = offset;
      }

      if (this.timeFirst) {
        params.from = this.timeFirst;
      }
      if (this.timeLast) {
        params.to = this.timeLast;
      }
      if (this.filters.search) {
        params.search = this.filters.search;
      }

      this.$store
        .dispatch("workshop/getAttendancesStudents", params)
        .then((response) => {
          this.working.wEntries = false;
          this.json_data = response.data.entity;
          callback(response.data.entity);
        })
        .catch((error) => {
          this.toast.failed = true;
          this.working.wEntries = false;
          console.log(error);
        });
    },
    //Crear PDF
    createEntriesPDF(from, to, data) {
      var branch = this.getBranch;
      var doc = new jsPDF( "p", "pt");

      var header = function (data) {
        var y = 40;
        //Estilo del archivo
        doc.setFont("helvetica");
        doc.setFontType("bold");
        doc.setFontSize(22);
        

        if (branch.img != null && branch.img != "") {
          var imgData =
            branch.img == null ? "" : "data:image/jpg;base64, " + branch.img;
          doc.addImage(imgData, "JPEG", data.settings.margin.left, y, 100, 100);
        }

        var title = "Colegio " + branch.name;
        var splitTitle = doc.splitTextToSize(title, 400);
        for (var i in splitTitle) {
          doc.text(splitTitle[i], 150, (y += 25));
        }

        doc.setFont("helvetica");
        doc.setFontSize(12);
        //Titulo del PDF
        doc.text("Reporte de salidas", 150, (y += 25));

        var splitAddress = doc.splitTextToSize(branch.address, 400);
        for (var i in splitAddress) {
          doc.text(splitAddress[i], 150, (y += 15));
        }

        doc.text("Periodo: " + from + " -- " + to, 150, (y += 15));
      };
      //Corregir
      var headers = [
        "Nivel",
        "Grupo",
        "Nombre",
        "Matrícula",
        "Fecha/Hora Solicitado",
        "Fecha/Hora Camino",
        "Fecha/Hora Entregado",
        "Nombre Solicitante",
        "Apellido Solicitante",
      ];
      //Datos del pdf
      var bodyTable = data.map(function (item) {
        return [
          item.level,
          item.grade,
          item.firstName,
          item.personId,
          moment(item.requestedTime).format("YYYY-MM-DD HH:mm:ss"),
          moment(item.calledTime).format("YYYY-MM-DD HH:mm:ss"),
          moment(item.deliveryTime).format("YYYY-MM-DD HH:mm:ss"),
          //Checar esto
          item.parentName,
          item.parentLastName || 'N/A',
        ];
      });

      doc.autoTable({
        head: [headers],
        body: bodyTable,
        margin: {
          top: 180,
        },
        styles: {
          fontSize: 9,
          verticalcell: 60,
          cellWidth: "grid",
        },
        didDrawPage: header,
      });
      //Nombre de archivo
      doc.save("ReporteDeSalidas.pdf");
    },
    getRoomID(idBranch) {
      return idBranch + "-deliveries";
    },
  },
  mounted() {
    this.getEntries();
  },
  beforeDestroy() {
    var room = this.getRoomID(this.getBranch.id);
    console.log('Unsubscribe from', room);
    this.$socket.emit("unsubscribe", room);
  },

  //Socket para datos
  sockets: {
  },


  watch: {
    getUser() {
      if (this.entries.length <= 0) {
        this.getEntries();
      }
    },
    timeFirst() {
      this.getEntries();
    },
    timeLast() {
      this.getEntries();
    },
    gradeGroup() {
      this.getEntries();
    },
  },

  //Fecha de inicio y fecha final predeterminada
  computed: {
    momentFormatFirst() {
      if (this.timeFirst != null) {
        return moment(this.timeFirst).format("DD/MM/YYYY");
      }
      return "";
    },
    momentFormatLast() {
      if (this.timeLast != null) {
        return moment(this.timeLast).format("DD/MM/YYYY");
      }
      return "";
    },
    ...mapGetters(["getUser", "getBranch"]),
  },
};
</script>

<style scoped>
.titleSearch .v-input .v-input__slot {
  border-radius: 33px !important;
}

.v-text-field--box .v-input__slot,
.v-text-field--outline .v-input__slot {
  display: flex !important;
  align-items: center !important;
  min-height: auto !important;
}

.new-entry {
  animation: difuminar 3s 1;
}

@keyframes difuminar {
    0% {
        background-color: rgba(143, 188, 143, 1);
    }
    100% {
        background-color: rgba(143, 188, 143, 0);
    }
}
</style>
<style scoped>
.table-full .v-datatable.v-table > tbody {
  max-height: calc(100vh - 426px);
  min-height: calc(100vh - 426px);
}

</style>
